module.exports = __webpack_public_path__ + "static/media/Nota-POSDemo.72453d87.png";